import { takeLatest, call, put, select, delay } from 'redux-saga/effects';

import { fetchJsonWithParsedError } from 'common/http';
import {
  filterOwnerSearchResults,
  userAndTeamAutocompleteUrl,
  getDomain,
} from 'common/components/AccessManager/Util';
import { CATALOG_SEARCH_DEBOUNCE_MILLISECONDS } from 'common/components/AccessManager/Constants';

import {
  ChangeOwnerActionTypes,
  ownerSearchQueryChanged,
  ownerSearchResultsFetchSuccess,
  ownerSearchResultsFetchFail,
} from 'common/components/AccessManager/actions/ChangeOwnerActions';

import { getCurrentOwner } from './Selectors';
import { ViewUser } from 'common/types/view';

// search for ALL users
function* onOwnerSearchQueryChanged(action: ReturnType<typeof ownerSearchQueryChanged>) {
  const { query } = action.payload;

  if (query) {
    // debounce this
    // (we're using takeLatest which will cancel this if it gets called again)
    yield delay(CATALOG_SEARCH_DEBOUNCE_MILLISECONDS);

    try {
      // @ts-expect-error TODO: Add appropriate return type to generator so yield doesn't return any
      const results = yield call(fetchJsonWithParsedError, userAndTeamAutocompleteUrl(query, getDomain()));

      const currentOwner: ViewUser | undefined = yield select(getCurrentOwner);

      // this will only filter out the current owner, unlike the
      // (much more complicated) filtering done when adding users
      const filteredResults = filterOwnerSearchResults(results, currentOwner!);

      yield put(ownerSearchResultsFetchSuccess(filteredResults));
    } catch (error) {
      yield put(ownerSearchResultsFetchFail(error));
    }
  }
}

export default [takeLatest(ChangeOwnerActionTypes.OWNER_SEARCH_QUERY_CHANGED, onOwnerSearchQueryChanged)];
